exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".header-container[data-v-5593287c]{width:100%;z-index:10;position:fixed;top:0;box-shadow:0 0 12px rgba(0,0,0,.5)}", "", {"version":3,"sources":["/builds/bis/app.callmeweb.eu/platform/src/components/Panel/HeaderContainer/style.sass"],"names":[],"mappings":"AACA,mCACE,WAAY,AACZ,WAAY,AACZ,eAAgB,AAChB,MAAO,AACP,kCAA4C,CAC7C","file":"style.sass","sourcesContent":["\n.header-container[data-v-5593287c] {\n  width: 100%;\n  z-index: 10;\n  position: fixed;\n  top: 0;\n  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.5);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5593287c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["./src/styles/defs/_colors.sass","./src/styles/defs/_fonts.sass","./src/styles/mixins/_mixins.sass"]}!./src/components/Panel/HeaderContainer/style.sass
// module id = 541
// module chunks = 3